import { ProductEntity, MaterialColorEntity } from 'src/modules/products';

export enum ProductsDetailsActions {
  FetchDetailsBegin = 'PRODUCTS/FETCH_DETAILS/BEGIN',
  FetchDetailsSuccess = 'PRODUCTS/FETCH_DETAILS/SUCCESS',
  FetchDetailsError = 'PRODUCTS/FETCH_DETAILS/ERROR',
  FetchRelatedProductsBegin = 'PRODUCTS/FETCH_DETAILS_RELATED/BEGIN',
  FetchRelatedProductsSuccess = 'PRODUCTS/FETCH_DETAILS_RELATED/SUCCESS',
  FetchRelatedProductsError = 'PRODUCTS/FETCH_DETAILS_RELATED/ERROR',
  FetchProductVariantsBegin = 'PRODUCTS/FETCH_VARIANTS/BEGIN',
  FetchProductVariantsSuccess = 'PRODUCTS/FETCH_VARIANTS/SUCCESS',
  FetchProductVariantsError = 'PRODUCTS/FETCH_VARIANTS/ERROR',
  FetchMaterialColorsBegin = 'PRODUCTS/FETCH_MATERIALS/BEGIN',
  FetchMaterialColorsSuccess = 'PRODUCTS/FETCH_MATERIALS/SUCCESS',
  FetchMaterialColorsError = 'PRODUCTS/FETCH_MATERIALS/ERROR',
  DisplayProductProperty = 'PRODUCTS/DISPLAY_PROPERTY',
}

export interface ProductsDetailsStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  isRelatedProductsLoading: boolean;
  isRelatedProductsLoaded: boolean;
  errorRelatedProducts: any;
  isLoadingProductVariants: boolean;
  isLoadedProductVariants: boolean;
  errorProductVariants: any;
  isLoadingMaterials: boolean;
  isLoadedProductMaterials: boolean;
  errorProductMaterials: any;
  product: ProductEntity;
  productSeriesProducts: ProductEntity[];
  relatedProducts: ProductEntity[];
  activeProductProperty: ProductProperties;
  materialColors: MaterialColorEntity[];
}

export enum ProductProperties {
  Details = 'Details',
  Colors = 'Colors',
  Dimensions = 'Dimensions',
  Downloads = 'Downloads',
}
